import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\"><path fill-rule=\"evenodd\" d=\"M12.031 3.5h-1.025a.22.22 0 0 0-.176.09L6.945 8.944 3.061 3.59a.22.22 0 0 0-.176-.09H1.86a.11.11 0 0 0-.09.174l4.821 6.646c.175.24.534.24.707 0l4.82-6.646a.109.109 0 0 0-.087-.174Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol